export const validatePhone = (phone) => {
  const regex = new RegExp(
    /(^02(0|1|2|5|7|8|9)[0-9]{6,8}$)|(^0(3|4|6|7|9)[0-9]{7}$)|(^0(3|4|6|7|9)[0-9]{7}$)|(^0(800|508)[0-9]{6,7}$)/
  );
  return regex.test(phone);
};
